export const BASE_URL = "https://backend.app20.co";
export const API_BASE_URL = BASE_URL;
